module.exports = __webpack_public_path__ + "img/passport-photo-template.e13c39f2.jpg";